import { has, get } from 'lodash';

const replaceSelfValue = (value, tokens) => {
    const path = value.replace('@self.', '');
    if (has(tokens, path)) {
        const value = get(tokens, path);
        if (value.includes('@self')) {
            throw new Error('Used wrong order of tokens because trying to replace a @self token with a @self token');
        }
        return value;
    }
    throw new Error(`Token value ${value} couldn't be found`);
};
const replaceTokens = (selection, lookOpObject) => {
    for (const key in selection) {
        const value = selection[key];
        if (typeof value === 'string') {
            if (value.includes('[')) {
                selection[key] = value.replace(/\[(.+?)\]/, (match, selector) => {
                    return replaceSelfValue(selector, lookOpObject);
                });
            }
            else if (value.includes('@self')) {
                selection[key] = replaceSelfValue(value, lookOpObject);
            }
        }
        if (typeof value === 'object') {
            selection[key] = replaceTokens(selection[key], lookOpObject);
        }
    }
    return selection;
};
const generateTokens = (tokens) => {
    return replaceTokens(tokens, tokens);
};

export { generateTokens, replaceTokens };
//# sourceMappingURL=generateTokens.js.map
